export const MENU_TYPE_SYSTEM=1;
export const MENU_TYPE_MODULE=2;
export const MENU_TYPE_PAGE=3;
export const MENU_TYPE_ACTION=4;
